import * as TYPES from './user-profile-actiontypes';

export const initialState = {
  firstName: null,
  lastName: null,
  userId: null,
  isEmailConfirmed: false,
  isEulaAccepted: false,
  isPasswordUpdateRequired: true,
  userProfileLoaded: false,
  termsOfUse: null,
  preferences: {},
  isAuthorizedRepresentative: false,
};

export const userProfileReducer = (state = initialState, action) => {
  let newState;

  switch (action.type) {
    case TYPES.USER_PROFILE_LOADED_SUCCESS:
      newState = { ...state, ...action.state };
      break;
    case TYPES.USER_PREFERENCE_SET: {
      const prefObj = { preferences: state.preferences };
      const keys = Object.keys(state.preferences);
      let keyFound = false;
      keys.some((key) => {
        if (key === action.name) {
          prefObj.preferences[key] = action.value;
          keyFound = true;
        }
        return keyFound;
      });

      if (keyFound === false) {
        prefObj.preferences[action.name] = action.value;
      }

      newState = { ...state, ...prefObj };
      break;
    }
    case TYPES.TERMSOFUSE_LOADED_SUCCESS:
      newState = { ...state, termsOfUse: action.termsOfUse };
      break;
    default:
      newState = state;
  }

  return newState;
};

export default userProfileReducer;
